module.exports = __webpack_public_path__ + "static/img/why-4.858f057f.jpg";